import React from "react";
import {
  Container,
  Typography,
  Box,
  Paper,
  Divider,
  Button,
} from "@mui/material";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";

const KYCRejected = ({ kycStatus }) => {
  const navigate = useNavigate();

  const handleUpdateClick = () => {
    navigate("/KYCNew");
  };

  const theme=useSelector((data)=>data.themeValue.colors)
  const themeMode=useSelector((data)=>data.themeValue.theme)
  return (
    <Container maxWidth="sm" sx={{ mt: 8 }}>
      <Paper
        elevation={4}
        sx={{
          p: 5,
          borderRadius: 4,
          textAlign: "center",
          boxShadow: themeMode==="light"?"0px 4px 20px rgba(0, 0, 0, 0.1)":"0px 4px 20px rgba(255, 255, 255, 0.1)",
          backgroundColor:theme.background
        }}
      >
        <Typography
          variant="h4"
          fontWeight="bold"
          color="error.main"
          gutterBottom
          sx={{color:theme.text}}
        >
          KYC Status
        </Typography>

        <Typography
          variant="h6"
          color="error.main"
          fontWeight="600"
          sx={{ mb: 4 }}
        >
          {kycStatus || "Rejected"}
        </Typography>

        <Divider sx={{ my: 3,backgroundColor:theme.text }} />

        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: 4,
            alignItems: "center",
            mt: 3,
          }}
        >
          {/* PAN Card Rejected */}
          <Box
            sx={{
              width: "100%",
              p: 2,
              border: "1px solid #ffcdd2",
              borderRadius: 3,
              backgroundColor: "#ffebee",
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              transition: "0.3s",
              "&:hover": { backgroundColor: "#ffcdd2" },
            }}
          >
            <Typography variant="subtitle1" fontWeight="bold">
              PAN Card
            </Typography>
            <HighlightOffIcon sx={{ color: "error.main", fontSize: 32 }} />
          </Box>

          {/* Aadhaar Card Rejected */}
          <Box
            sx={{
              width: "100%",
              p: 2,
              border: "1px solid #ffcdd2",
              borderRadius: 3,
              backgroundColor: "#ffebee",
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              transition: "0.3s",
              "&:hover": { backgroundColor: "#ffcdd2" },
            }}
          >
            <Typography variant="subtitle1" fontWeight="bold">
              Aadhaar Card
            </Typography>
            <HighlightOffIcon sx={{ color: "error.main", fontSize: 32 }} />
          </Box>
        </Box>

        {/* Update KYC Button */}
        <Button
          variant="contained"
          color="primary"
          fullWidth
          onClick={handleUpdateClick}
          sx={{
            mt: 5,
            textTransform: "none",
            fontWeight: "bold",
            py: 1.5,
            fontSize: 16,
            borderRadius: 2,
          }}
        >
          Update KYC
        </Button>
      </Paper>
    </Container>
  );
};

export default KYCRejected;
